import { Alert, AlertDescription } from '@/components/ui/alert';
import { Clock } from 'lucide-react';

/**
 * Aviso de espera para empresa grande (SPEC-006, decisão 10): o cálculo da Apuração de IBS e CBS
 * pode levar minutos para quem tem muitas notas. Mostrado enquanto a aba "Apuração de IBS e CBS" e
 * os cartões da Gestão de Impostos (Situação Atual) carregam.
 */
export function AvisoCalculoDemorado() {
  return (
    <Alert className="mb-4 border-amber-500/40 bg-amber-500/5">
      <Clock className="text-amber-600" />
      <AlertDescription>
        Empresa com muitas notas: o cálculo pode levar alguns minutos.
      </AlertDescription>
    </Alert>
  );
}
